import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { CollectionRequestBuilder } from '@web/common';
import { isNil, Nillable } from '@web/utils';
import { AdminCosmeticCollectionItemResponse } from '../api/responses';
import { AdminCosmeticApiService } from '../api/services';

@Injectable({
  providedIn: 'root',
})
export class AdminCosmeticSelectItemsProviderService {
  private readonly cosmeticApi = inject(AdminCosmeticApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  /* prettier-ignore */
  public fetchCollectionAsSelectItems<Key extends keyof AdminCosmeticCollectionItemResponse>(key: Key, query: Nillable<string> = null): Observable<SelectItem<AdminCosmeticCollectionItemResponse[Key]>[]> {
    return this.cosmeticApi
      .fetchCollection(
        {
          request: this.collectionRequestBuilder
            .query(query)
            .page(1)
            .pageSize(90)
            .sorts((builder) => [builder.ascendingFor('name').build()])
            .build(),
          skipByLoading: true,
          cacheable: true,
        }
      )
      .pipe(
        map(({ items }) =>
          items
            .filter(item => {
              if (isNil(query)) {
                return item;
              }

              if (item.cosmeticBrand) {
                return item.name.toLowerCase().includes(query) || item.cosmeticBrand.name.toLowerCase().includes(query);
              }

              return item.name.toLowerCase().includes(query);
            })
            .map(
              (item) => new SelectItem(
                item.cosmeticBrand ? `[${item.cosmeticBrand?.name}] ${item.name}` : item.name,
                item[key],
              ),
            ),
        ),
        catchError(() => of([])),
      );
  }
}
